import logo from "./logo.svg";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { GlobalProvider } from "./context/GlobalContext";
import Dashboard from "./pages/homepage";
import Login from "./pages/loginpage";
import RegisterPage from "./pages/registerpage";
import Admin from "./pages/adminpage";
import Cookies from "js-cookie";
import NotFoundPage from "./pages/notfoundpage";
import ListJobPage from "./pages/listJobPage";
import TableListJobPage from "./pages/tableListJobPage";
import AddFormPage from "./pages/addFormPage";
import ProfilPage from "./pages/profilePage";
import ChangePasswordPage from "./pages/changePasswordPage";
import EditFormPage from "./pages/editFormPage";
import DetailPage from "./pages/detailpage";
function App() {
  const LoginRoute = (props) => {
    if (Cookies.get("token") === undefined) {
      return <Navigate to={"/"} />;
    } else if (Cookies.get("token") !== undefined) {
      return props.children;
    }
  };
  const LoginRoute2 = (props) => {
    if (Cookies.get("token") === undefined) {
      return <Navigate to={"/login"} />;
    } else if (Cookies.get("token") !== undefined) {
      return props.children;
    }
  };
  return (
    <>
      <BrowserRouter>
        <GlobalProvider>
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="*" element={<NotFoundPage />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<RegisterPage />} />

            <Route
              path="/dashboard/list-job-vacancy/form"
              element={
                <LoginRoute2>
                  <AddFormPage />
                </LoginRoute2>
              }
            />
            <Route
              path="/dashboard/list-job-vacancy/form/edit/:IdData"
              element={
                <LoginRoute2>
                  <EditFormPage />
                </LoginRoute2>
              }
            />
            <Route
              path="/dashboard/profile"
              element={
                <LoginRoute2>
                  <ProfilPage />
                </LoginRoute2>
              }
            />
            <Route
              path="/dashboard/change-password"
              element={
                <LoginRoute2>
                  <ChangePasswordPage />
                </LoginRoute2>
              }
            />

            <Route path="/job-vacancy" element={<ListJobPage />} />
            <Route path="/job-vacancy/:id" element={<DetailPage />} />
            <Route
              path="/admin"
              element={
                <LoginRoute2>
                  <Admin />
                </LoginRoute2>
              }
            />
            <Route
              path="/dashboard/list-job-vacancy"
              element={
                <LoginRoute2>
                  <TableListJobPage />
                </LoginRoute2>
              }
            />
          </Routes>
        </GlobalProvider>
      </BrowserRouter>
    </>
  );
}

export default App;
